var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Row, Col } from '../Grid';
import { useTheme } from '../Theme/Theme';
import { listItem as listStyle } from './style';
import { lightText } from '../../helpers/color';
import { Text } from '../Text';
import { classes, getColor } from '../../helpers';
export const ListItem = (props) => {
    const { style = {}, onClick, avatar, children, subtitle, action, selected, gutter = [0, '12px 16px 12px 18px'], element, className } = props, rest = __rest(props, ["style", "onClick", "avatar", "children", "subtitle", "action", "selected", "gutter", "element", "className"]);
    const theme = useTheme();
    const css = listStyle(theme.background);
    const Element = (p) => React.cloneElement(element || React.createElement("li", null), Object.assign({ className: classes(className, css, 'list-item'), onClick: onClick, style: Object.assign({ background: selected && theme.primary, color: selected && getColor(theme.primary) }, style) }, p));
    return (React.createElement(Element, Object.assign({}, rest),
        React.createElement(Row, { wrap: "nowrap", gutter: gutter, alignItems: "center" },
            avatar && React.createElement(Col, { flex: "0 1 auto" }, avatar),
            children && (React.createElement(Col, { flex: "1 0 auto" },
                React.createElement("div", null, children),
                React.createElement(Text, { fontSize: "12px", color: lightText(theme) }, subtitle))),
            action && React.createElement(Col, { flex: "0 1 auto" }, action))));
};
//# sourceMappingURL=ListItem.js.map